import { FC, useState } from 'react'

import { Grid } from '@material-ui/core'
import Button from '../../../control/button/button'
import { Form } from 'react-final-form'
import { makeStyles } from '@material-ui/core/styles'

import useTranslate from '../../../i18n/useTranslate'

import MyTextfield from '../../../control/textfield/textfield'
import MultiSelect from '../../../control/multiSelect/multiSelect'
import { SearchFormT } from '../../../services/um/useExternalResearcher'
import { ValidationErrors } from 'final-form'

interface PanelProps {
    onSubmit: (values: SearchFormT) => void
    initialSearch: SearchFormT
    onReset: (form: any) => void
    onEnter: (values: SearchFormT) => void
}

const Panel: FC<PanelProps> = ({ onSubmit, initialSearch, onReset, onEnter }) => {
    const translate = useTranslate()
    const classes = useStyles()
    const defaultSelect = initialSearch.statusID
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    const options = [
        { label: { th: 'รอพิจารณา', en: 'Waitting' }, value: '1' },
        { label: { th: 'อนุมัติ', en: 'Approved' }, value: '2' },
        { label: { th: 'ไม่อนุมัติ', en: 'Reject' }, value: '3' },
    ]

    const validation = (values: SearchFormT) => {
        const errors: ValidationErrors = {}

        if (!values.statusID) {
            errors.statusID = translate.get('MESSAGE.M016')
        }
        if (values.statusID && values.statusID.length === 0) {
            errors.statusID = translate.get('MESSAGE.M016')
        }

        return errors
    }

    return (
        <Form onSubmit={onSubmit} initialValues={initialSearch} validate={validation}>
            {({ handleSubmit, form, values }) => {
                return (
                    <Grid container spacing={2} className={classes.root}>
                        <Grid item xs={12} sm={6}>
                            <MyTextfield
                                name="keyword"
                                materialInputProps={{
                                    label: translate.get('UM.EXTERNAL-RESEARCHER.NAME'),
                                    disabled: false,
                                    placeholder: translate.get('UM.EXTERNAL-RESEARCHER.NAME'),
                                    size: 'small',
                                }}
                                onEnter={() => onEnter(values)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MultiSelect
                                name="statusID"
                                option={options.map((item) => ({
                                    ...item,
                                    label: item.label[lang],
                                }))}
                                label={translate.get('UM.EXTERNAL-RESEARCHER.STATUS')}
                                placeholder={translate.get('UM.EXTERNAL-RESEARCHER.STATUS')}
                                size="small"
                                defaultValue={defaultSelect}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify="flex-end" spacing={2}>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="default"
                                        onClick={() => {
                                            form.reset()
                                            onReset(form)
                                        }}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.RESET')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        size={'large'}
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        className={classes.btnSearch}
                                    >
                                        {translate.get('BUTTON.SEARCH')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            }}
        </Form>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '15px',
    },
    clear: {
        textDecoration: 'underline',
        cursor: 'pointer',
        padding: '0px 1.5rem',
        alignSelf: 'center',
    },
    btnSearch: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
    },
}))

export default Panel
